exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-0f6a8b76]{margin-bottom:1rem;font-size:1.25rem}h2[data-v-0f6a8b76]{margin-top:1.5rem;font-weight:600}h2[data-v-0f6a8b76],p[data-v-0f6a8b76]{margin-bottom:.5rem}ul[data-v-0f6a8b76]{margin-left:2rem;margin-top:1rem;margin-bottom:1rem;list-style-type:disc}", ""]);

// exports
